module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Thin.woff2
// module id = 260
// module chunks = 0